<template>
  <div class="container">
    <!--进行板块划分-->
    <div class="block">
      <div class="title-wrap">
        <div class="title-name" @click="$router.back(-1)">
          <i class="el-icon-arrow-left"></i>
          成员数据明细
        </div>
      </div>
      <!-- <div class="title-wrap">
        <div class="title-name">成员数据明细</div>
      </div>  -->
      <div class="content-inner-wrap">
        <div class="member-info" :member-data="detailData">
          <!--        <img class="avator" :src="detailsrc">   -->
          <img class="avator" :src="membersrc" />
          <div class="info">
            <h2>{{ memberName || 0 }}</h2>
            <p>{{ memberType | memberTypeJudge }}</p>
            <p>加入时间：{{ inTime || 0 }}</p>
            <p>作品数量：{{ productCount || 0 }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">数据总览</div>
        <div class="title-desc">仅当成员签约后，收益计入工作室</div>
      </div>
      <div class="data-view">
        <div id="card">
          <div
            class="card-wrap"
            v-for="(item, index) in viewData"
            :key="index"
            :item="item"
          >
            <p class="card-title">{{ item.title }}</p>
            <p class="card-value">
              {{ item.value | regroupWan
              }}<span class="card-value-unit" v-if="item.value >= 10000">
                万
              </span>
            </p>
            <p class="card-content">
              <span style="margin-right: 8px">昨日</span
              >{{ item.yesterday | regroupWan
              }}<span class="card-value-unit" v-if="item.yesterday >= 10000">
                万</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">作品数据详情</div>
        <div class="title-desc">所选时间范围内有产生数据的作品详情</div>
      </div>
      <div class="content-inner-wrap">
        <div class="data-filter">
          <span class="mgr25">选择日期</span>
          <el-date-picker
            v-model="productDate"
            type="daterange"
            align="left"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-button
            @click="handlePDateBtnClicked"
            class="search_btn"
            type="info"
          >
            查找
          </el-button>
          <span class="download-wrap" @click="exportFn">
            <img src="@/assets/images/icon_export.png" />
            <span>导出数据</span>
          </span>
        </div>
        <div class="data-table" v-loading="productDataLoading">
          <el-table :data="productData" stripe>
            <el-table-column
              v-for="(item, index) in productColData"
              :key="index"
              :align="item.align"
              :prop="item.prop"
              :label="item.label"
              :class-name="item.classname"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="data-filter-page">
          <el-pagination
            background
            layout="prev,pager,next,jumper"
            @current-change="pDPaginationChange"
            :total="productDataCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <div class="block">
      <div class="title-wrap">
        <div class="title-name">作品收入</div>
        <div class="title-desc">所选时间内作品产生的收入</div>
      </div>
      <div class="content-inner-wrap">
        <div class="data-filter">
          <span class="mgr25">选择日期</span>
          <el-date-picker
            v-model="InProductDate"
            type="daterange"
            align="left"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-button
            @click="handlePIDateBtnClicked"
            class="search_btn"
            type="info"
          >
            查找
          </el-button>
          <span class="download-wrap" @click="inExportFn">
            <img src="@/assets/images/icon_export.png" />
            <span>导出数据</span>
          </span>
        </div>
        <div class="data-table" v-loading="InproductDataLoading">
          <el-table :data="InproductData" stripe>
            <el-table-column
              v-for="(item, index) in InproductColData"
              :key="index"
              :align="item.align"
              :prop="item.prop"
              :label="item.label"
              :class-name="item.classname"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="data-filter-page">
          <el-pagination
            background
            layout="prev,pager,next,jumper"
            @current-change="IDPaginationChange"
            :total="InproductDataCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
// import HelpTip from '@/components/HelpTip';
import {
  getProductDetailData,
  getProductDeatilIncome,
  exportStudioInteraction,
  getStudioMembersOverviewData,
  InExportStudioInteraction,
  getStudioMemBaseinfo,
} from '@/api/studio';

export default {
  components: {
    // HelpTip
  },
  data() {
    return {
      detailData: [],
      // viewData:[],
      OverviewData: {},
      memberName: '',
      memberType: this.$route.params.memberType,
      productCount: '',
      inTime: '',
      membersrc: '',
      productDate: '',
      InProductDate: '',
      productDataCount: 0,
      InproductDataCount: 0,
      productData: [],
      InproductData: [],
      lastProductDate: [],
      lastInProductDate: [],
      productDataLoading: false,
      InproductDataLoading: false,
      productPagniation: {
        page_size: 10,
        page: 1,
      },
      InProductPagniation: {
        page_size: 10,
        page: 1,
      },
      viewData: [
        {
          title: '本月广告展示',
          value: 0,
          yesterday: 0,
        },
        {
          title: '本月贡献点',
          value: 0,
          yesterday: 0,
        },
        {
          title: '本月迷你豆',
          value: 0,
          yesterday: 0,
        },
        {
          title: '本月地图下载',
          value: 0,
          yesterday: 0,
        },
      ],
      pickerOptions: {
        //判断
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcurts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近3个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      productColData: [
        {
          align: 'center',
          label: '作品名称',
          prop: 'product_name',
          classname: 'tb-product_name',
        },
        {
          align: 'center',
          label: '上传时间',
          prop: 'map_create_time',
          classname: 'tb-map_create_time',
        },
        {
          align: 'center',
          label: '今日下载(预估)',
          prop: 'today_download',
          classname: 'tb-today_download',
        },
        {
          align: 'center',
          label: '昨日下载数',
          prop: 'yesterday_download_count',
          classname: 'tb-yesterday_download_count',
        },
        {
          align: 'center',
          label: '累计下载',
          prop: 'download',
          classname: 'tb-download',
        },
        {
          align: 'center',
          label: '累计游戏次数',
          prop: 'play_count',
          classname: 'tb-play_count',
        },
        {
          align: 'center',
          label: '累计游戏时长',
          prop: 'play_time',
          classname: 'tb-play_time',
        },
      ],
      InproductColData: [
        {
          align: 'center',
          label: '作品名称',
          prop: 'product_name',
          classname: 'tb-product_name',
        },
        {
          align: 'center',
          label: '上传日期',
          prop: 'date',
          classname: 'tb-date',
        },
        {
          align: 'center',
          label: '昨日广告播放数',
          prop: 'yesterday_ad_count',
          classname: 'tb-yesterday_ad_count',
        },
        {
          align: 'center',
          label: '广告播放数',
          prop: 'ad_count',
          classname: 'tb_ad_count ',
        },
        {
          align: 'center',
          label: '累计广告收益',
          prop: 'ad_income',
          classname: 'tb_ad_income ',
        },
        {
          align: 'center',
          label: '累计迷你豆',
          prop: 'minibean',
          classname: 'tb-minibean',
        },
        {
          align: 'center',
          label: '累计贡献点',
          prop: 'contribution',
          classname: 'tb-contribution',
        },
        {
          align: 'center',
          label: '累计迷你点',
          prop: 'minipoint',
          classname: 'tb-minipoint',
        },
      ],
    };
  },
  filters: {
    regroupWan(num, toFixed) {
      if (num >= 10000) {
        return (num / 10000).toFixed(toFixed || 2);
      } else if (`${num}`.includes('.')) {
        return num.toFixed(toFixed || 2);
      } else {
        return toFixed ? Number(num).toFixed(toFixed) : num;
      }
    },
    memberTypeJudge(memberType) {
      return memberType == 1 ? '室长' : '签约成员';
    },
  },
  mounted() {
    //初始化表达数据
    this.getMemberBaseinfo();
    this.getProductData();
    this.getProductInData();
    this.getStudioMembersData();
  },
  created() {
    // const currTime=Date.now();
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.productDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
    this.InProductDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  methods: {
    //获取作品详情表
    async getProductData() {
      this.productDataLoading = true;
      this.lastProductDate = this.productDate;
      const res = await getProductDetailData(
        Object.assign(this.productPagniation, {
          start_time: parseInt(this.productDate[0] / 1000, 10),
          end_time: parseInt((this.productDate[1] + ONE_DAY_TIME) / 1000, 10),
          json: 1,
          member_id: this.$route.params.member_id,
        }),
      );
      this.productDataLoading = false;
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.productData = list.map(item => {
            item.play_time = Number(item.play_time).toFixed(2);
            return item;
          });
        }
        this.productDataCount = parseInt(res.data.total_count, 10);
      }
    },
    //获取作品收入
    async getProductInData() {
      this.InproductDataLoading = true;
      this.lastInProductDate = this.InProductDate;
      const res = await getProductDeatilIncome(
        Object.assign(this.InProductPagniation, {
          start_time: parseInt(this.InProductDate[0] / 1000, 10),
          end_time: parseInt((this.InProductDate[1] + ONE_DAY_TIME) / 1000, 10),
          member_uin: this.$route.params.member_id,
        }),
      );
      this.InproductDataLoading = false;
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.InproductData = list.map(item => {
            item.ad_income = Number(item.ad_income).toFixed(3);
            item.contribution = Number(item.contribution).toFixed(3);
            return item;
          });
        }
        this.InproductDataCount = parseInt(res.data.total_count, 10);
      }
    },
    //获取个人成员的介绍
    async getMemberBaseinfo() {
      let data = {
        member_id: this.$route.params.member_id,
        json: 1,
      };
      const res = await getStudioMemBaseinfo(data);
      this.memberName = res.data.name;
      this.inTime = res.data.join_time;
      this.productCount = res.data.map_count;
      this.membersrc = res.data.avatar_url;
    },

    //获取个人成员的收益概览
    async getStudioMembersData() {
      let data = { member_uin: this.$route.params.member_id };
      const res = await getStudioMembersOverviewData(data);
      this.OverviewData = res.data;
      this.viewData = [
        {
          title: '本月广告展示',
          value: this.OverviewData.month_ad_count,
          yesterday: this.OverviewData.yesterday_ad_count,
        },
        {
          title: '本月贡献点',
          value: this.OverviewData.month_contribution,
          yesterday: this.OverviewData.yesterday_contribution,
        },
        {
          title: '本月迷你豆',
          value: this.OverviewData.month_minibean,
          yesterday: this.OverviewData.yesterday_minibean,
        },
        {
          title: '本月地图下载',
          value: this.OverviewData.month_down,
          yesterday: this.OverviewData.yesterday_down,
        },
      ];
      //console.log(this.viewData)
    },
    handlePDateBtnClicked() {
      //this.getProductData();
      if (
        this.lastProductDate[0] === this.productDate[0] &&
        this.lastProductDate[1] === this.productDate[1]
      )
        return;
      this.getProductData();
    },
    handlePIDateBtnClicked() {
      if (
        this.lastInProductDate[0] === this.InProductDate[0] &&
        this.lastInProductDate[1] === this.InProductDate[1]
      )
        return;
      this.getProductInData();
    },
    //数据导出
    exportFn() {
      this.fetchExport();
    },
    inExportFn() {
      this.fetchInExport();
    },
    //下载个人作品数据
    async fetchExport() {
      let data = {
        start_time: parseInt(this.productDate[0] / 1000, 10),
        end_time: parseInt((this.productDate[1] + 86399000) / 1000, 10),
        member_id: this.$route.params.member_id,
        json: 1,
      };
      try {
        const res = await exportStudioInteraction(data);
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    //下载个人收入数据
    async fetchInExport() {
      let data = {
        start_time: parseInt(this.InProductDate[0] / 1000, 10),
        end_time: parseInt((this.InProductDate[1] + 86399000) / 1000, 10),
        member_uin: this.$route.params.member_id,
      };
      try {
        const res = await InExportStudioInteraction(data);
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    pDPaginationChange(currPage) {
      (this.productPagniation.page = currPage), this.getProductData();
    },
    IDPaginationChange(currPage) {
      (this.InProductPagniation.page = currPage), this.getProductInData();
    },
  },
};
</script>
<style src="@/assets/styles/introduce-common.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.title-wrap-back {
  font-size: 24px;
  color: #595959;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(217, 217, 217, 1);
  // margin-bottom: 24px;
  i {
    margin-left: 4px;
  }
  .title-name {
    em {
      cursor: pointer;
    }
    label {
      color: #8c8c8c;
    }
  }
}
.help-right {
  float: right;
  margin-right: 20px;
  padding-top: 8px;
  .detail-des {
    word-wrap: break-all;
  }
}
.member-info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-family: Helvetica;
  .avator {
    width: 101px;
    height: 100px;
    margin-right: 20px;
    border-radius: 8px;
    // margin-top:15px;
    border: 1px solid #f565a5;
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    h2 {
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 14px;
      margin-top: 25px;
      color: #000000;
    }
    p {
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 14px;
      color: #262626;
    }
  }
}
.data-view {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  .card-wrap {
    width: 237px;
    height: 176px;
    background: #fafafa;
    border-radius: 8px;
    margin-right: 16px;
    .card-title {
      font-size: 16px;
      color: #55514c;
      line-height: 19px;
      margin: 24px auto 13px 20px;
    }
    .card-content {
      font-size: 16px;
      color: #55514c;
      line-height: 22px;
      margin: 18px auto 24px 20px;
      .card-value-unit {
        font-size: 14px;
      }
    }
    .card-value {
      margin-left: 20px;
      font-size: 40px;
      color: #fd9b21;
      line-height: 48px;
      .card-value-unit {
        font-size: 18px;
      }
    }
  }
}
.download-wrap {
  float: right;
  border-radius: 4px;
  font-size: 11px;
  margin-top: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #2b6ddf;
  img {
    margin-right: 8px;
  }
}
.data-table {
  margin-top: 28px;
  border: 1px solid #d9d9d9;
  // overflow: hidden;
  border-radius: 3px;
  ::v-deep .el-table tr:last-child td {
    border-bottom: none;
  }
  ::v-deep .el-table::before {
    background: transparent;
  }
  ::v-deep .el-table th {
    background: #fafafa;
    line-height: 29px;
  }
  ::v-deep .el-table td {
    line-height: 29px;
    padding: 7px 0 6px;
  }
}
.search_btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
  color: #595959;
  border-right: 1px solid #d9d9d9;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  background-color: #f4f4f5;
}
#card {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
</style>
